/* SNARKS theme — minimal interactions. No external deps. */
(function(){
  'use strict';

  // Mobile menu toggle
  var burger = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function(){
      var closed = mobileNav.hasAttribute('hidden');
      if (closed) {
        mobileNav.removeAttribute('hidden');
        burger.setAttribute('aria-expanded', 'true');
      } else {
        mobileNav.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Variant select -> update price + hidden id on product form
  var form = document.getElementById('product-form');
  if (form) {
    var select = form.querySelector('[data-variant-select]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-current-price]');
    if (select && idInput) {
      select.addEventListener('change', function(){
        var opt = select.options[select.selectedIndex];
        idInput.value = opt.value;
        if (priceEl && opt.dataset.price) { priceEl.textContent = opt.dataset.price; }
      });
    }
  }
})();

/* Product gallery thumbs + size chart modal */
(function(){
  'use strict';
  var main = document.getElementById('pgMain');
  var thumbs = document.querySelectorAll('.pg-th');
  if (main && thumbs.length) {
    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){
        var full = btn.getAttribute('data-full');
        if (full) { main.src = full; }
        thumbs.forEach(function(b){ b.classList.remove('is-on'); });
        btn.classList.add('is-on');
      });
    });
  }

  var modal = document.querySelector('[data-chart]');
  var openBtn = document.querySelector('[data-chart-open]');
  var closeBtn = document.querySelector('[data-chart-close]');
  if (modal && openBtn) {
    openBtn.addEventListener('click', function(){ modal.removeAttribute('hidden'); });
    if (closeBtn) closeBtn.addEventListener('click', function(){ modal.setAttribute('hidden',''); });
    modal.addEventListener('click', function(e){ if (e.target === modal) modal.setAttribute('hidden',''); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') modal.setAttribute('hidden',''); });
  }
})();

/* Cross-sell add-to-cart handler now lives solely in snippets/cross-sell.liquid.
   The duplicate handler that used to be here caused a single click to add the
   item to the cart twice. Removed to fix the double-add. */

/* Bundle tiers -> quantity */
(function(){
  'use strict';
  var qty = document.querySelector('[data-qty-input]');
  var tiers = document.querySelectorAll('[data-tier]');
  if (!qty || !tiers.length) return;
  function sync(){
    var c = document.querySelector('[data-tier]:checked');
    if (c) qty.value = c.value || '1';
  }
  tiers.forEach(function(r){ r.addEventListener('change', sync); });
  sync();
})();
